import Controller from '../utils/Controller';
import { decorate, computed, action, observable, reaction } from 'mobx';
import { notification } from 'antd';

export const TEAM_TYPE = {
  "Apripista": 0,
  "Pace Car": 1,
  "Scopa": 2,
  "Technical car": 3,
  "Medical car": 4,
  "Staff": 5
};
export const TEAM_COLORS = {
  "Apripista": '#D9A0A2',
  "Pace Car": '#133b6b',
  "Scopa": '#575657',
  "Technical car": '#fe7d07',
  "Medical car": '#dc1313'
}

export const TEAM_TYPE_ARRAY = ['Apripista', 'Pace Car', 'Scopa', 'Technical car', 'Medical car', 'Staff']

class Teams extends Controller {
  constructor(options, manager) {
    super(options, manager);
    this.fetched = false;
    this.list = [];
    this.current = null;
  }
 
  get map() {
    return this.list
      .reduce((agg, curr) => {
        agg[curr.id] = curr;
        return agg;
      }, {});
  }


  get name() {
    return 'teams'
  }

  get free () {
    return this.list.filter(item => !item.assegnatoA);
  }

  get priority() {
    return 1002;
  }

  async init() {
    super.init();
    reaction(
      () => this.manager.controllers.eventi.current,
      () => {
        this.list = [];
        this.fetched = false;
      }
    );
    this.manager.controllers.websocket.addEventListener('team_updated', this.update_team.bind(this));
    this.manager.controllers.websocket.addEventListener('team_released', this.onRelease.bind(this));
    this.manager.controllers.websocket.addEventListener('team_assigned', this.onAssigned.bind(this));
    this.manager.controllers.connection.addEventListener('reconnect', this.onReconnection.bind(this));
  }

  async onReconnection() {
    if (this.fetched) {
      await this.fetch();
    } else {
      if (this.list.length > 0) {
        for (let i = 0; i < this.list.length; i++) {
          await this.get(this.list[i].id);
        }
      }
    }
  }

  async reload() {
    if (this.fetched) {
      await this.fetch();
    } else {
      for (let i = 0; i < this.list.length; i++) {
        await this.get(this.list[i].id, true)
      }
    }
  }


  update_team(body) {
    if (this.current.id === body.id) {
      this.current = body;
    }
  }

  onAssigned(body) {
    if (body.team === this.current.id) {
      notification.open({
        message: 'Eliminazione assegnazione',
        description: 'Non sei più assegnato alla segnalazione precedente'
      });
      this.current = {
        ...this.current,
        assegnatoA: body.segnalazione
      }
    }
  }

  onRelease(body) {
    if (body === this.current.id) {
      notification.open({
        message: 'Eliminazione assegnazione',
        description: 'Non sei più assegnato alla segnalazione precedente'
      });
      this.current = {
        ...this.current,
        assegnatoA: null
      };
      this.manager.controllers.segnalazioni.setCurrent(null);
    }
  }


  async getByAssignement(id) {
    const currentEvent = this.manager.controllers.eventi.current;
    if (currentEvent) {
      const fromCache = this.list.filter(item => item.assegnatoA === id);
      if (fromCache.length > 0) {
        return fromCache;
      } else {
        const result = await this.manager.controllers.api.get(`/eventi/${currentEvent.id}/teams?segnalazione=${id}`)
        this.list = [...this.list, ...result.Items]
      }
    }
  }

  async release(id) {
    const currentEvent = this.manager.controllers.eventi.current;
    if (currentEvent) {
      const result = await this.manager.controllers.api.post(`/eventi/${currentEvent.id}/teams/${id}/release`);
      this.replace(id, result.Item)
    }
  }

  async assign(team, segnalazione) {
    const currentEvent = this.manager.controllers.eventi.current;
    if (currentEvent) {
      const result = await this.manager.controllers.api.post(`/eventi/${currentEvent.id}/teams/${team}/assign`, {
        body: {
          segnalazione
        }
      });
      this.replace(team, result.Item)
    }
  }

  async get(id, nocache = null) {
    if (!nocache && this.map[id]) {
      return this.map[id];
    } else {
      const currentEvent = this.manager.controllers.eventi.current;
      if (currentEvent) {
        const result = await this.manager.controllers.api.get(`/eventi/${currentEvent.id}/teams/${id}`);
        this.list = [...this.list, result.Item];
        return result.Item;
      }
    }
  }

  async delete(id) {
    const currentEvent = this.manager.controllers.eventi.current;
    if (currentEvent) {
      const result = await this.manager.controllers.api.del(`/eventi/${currentEvent.id}/teams/${id}`) 
      this.list = this.list.filter(item => item.id !== result.Item.id);
    }
  }

  async fetch(evento) {
      const result = await this.manager.controllers.api.get(`/eventi/${evento}/teams?utente=${this.manager.controllers.auth.user.username}`) 
      this.list = result.Items;
      this.fetched = true;
  }

  async create(values) {
    const currentEvent = this.manager.controllers.eventi.current;
    if (currentEvent) {
      const result = await this.manager.controllers.api.post(`/eventi/${currentEvent.id}/teams`, {
        body: values
      });
      if (result) {
        this.list = [...this.list, result.Item]
      }
    }
  }

  async update(id, values) {
    const currentEvent = this.manager.controllers.eventi.current;
    if (currentEvent) {
      const result = await this.manager.controllers.api.put(`/eventi/${currentEvent.id}/teams/${id}`, {
        body: values
      });
      this.replace(id, result.Item)
    }
  }



  find(id) {
    return this.list.findIndex(tappa => tappa.id === id);
  }

  replace(id, valore) {
    const temp = [...this.list];
    const idx = this.find(id);
    if (idx !== -1) {
      temp[idx] = valore;
      this.list = temp;
    }
  }

  setCurrent(team)  {
    this.current = team;
  }
  
}

export default decorate(Teams, {
  list: observable,
  current: observable,
  map:computed,
  free: computed,
  fetch: action,
  delete: action,
  update: action,
  create: action,
  setCurrent: action
});